import React from "react";
import * as Sentry from "@sentry/react";
import PropTypes from "prop-types";
import ErrorPage from "pages/common/ErrorPage/ErrorPage";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error, { extra: errorInfo });
  }

  clearError = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="h-100 d-flex align-items-center justify-content-center">
          <ErrorPage clearError={this.clearError} />
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
